export const translations = {
  ru: {
    common: {
      processing: 'Обработка...',
      analyze: 'Анализировать',
      cancel: 'Отмена',
      close: 'Закрыть',
      clear: 'Очистить',
      or: 'или',
      error: 'Ошибка',
      success: 'Успешно',
      loading: 'Загрузка...',
      showRawData: 'Показать исходные данные',
    },
    nav: {
      features: 'Возможности',
      demo: 'Демо',
      privacy: 'Конфиденциальность',
      contacts: 'Контакты',
      tryDemo: 'Попробовать демо',
      solutions: 'Решения',
      industries: 'Отрасли',
      security: 'Безопасность',
      technology: 'Технология',
      cases: 'Кейсы',
      about: 'О компании',
      contactUs: 'Связаться с нами',
      focus: 'Фокус',
    },
    focus: {
      badge: 'Приватная бета',
      kicker: 'Razuma Focus — ваше место для работы',
      title: 'В своём темпе. Одна задача. Один посильный шаг.',
      subtitle: 'Нума рядом, когда нужна помощь.',
      tabs: {
        movement: 'Движение',
        session: 'Моя сессия',
        how: 'Как это работает',
      },
      movement: {
        title: 'Движение',
        prompt: 'Что хочется сдвинуть с места?',
        hint: 'Выберем одно небольшое действие.',
        placeholder: 'Опишите задачу своими словами…',
        generate: 'Разбить задачу',
        regenerate: 'Собрать заново',
      },
      presets: {
        presentation: 'Подготовить презентацию',
        letter: 'Написать письмо',
        study: 'Подготовиться к учёбе',
      },
      plan: {
        heading: 'Ваш план по шагам',
        count: 'Шагов: {count}',
        addStep: 'Добавить шаг',
        remove: 'Удалить шаг',
        empty: 'Опишите задачу — и появится план по шагам.',
        manual: 'Новый шаг',
        timeLimit: 'Ограничить время',
        blockDuration: '25 минут',
        numaNearby: 'Нума рядом',
        prepare: 'Подготовить сессию',
        steps: {
          generic: {
            clarify: 'Сформулировать, что именно нужно сделать',
            plan: 'Наметить самый маленький первый шаг',
            firstStep: 'Сделать этот шаг (5–10 минут)',
            review: 'Посмотреть результат и решить, что дальше',
          },
          presentation: {
            goal: 'Сформулировать главную мысль',
            structure: 'Набросать структуру',
            draft: 'Собрать черновик',
            visual: 'Добавить визуальный акцент',
            rehearse: 'Проговорить вслух',
          },
          letter: {
            goal: 'Понять цель письма',
            points: 'Выписать главные пункты',
            draft: 'Написать черновик',
            send: 'Проверить и отправить',
          },
          study: {
            topic: 'Определить тему и объём',
            materials: 'Собрать материалы',
            firstPass: 'Пройти первый блок',
            selfCheck: 'Проверить себя вопросами',
          },
        },
      },
      session: {
        title: 'Моя сессия',
        text: 'Один шаг за раз. Запустите таймер и делайте паузу в любой момент.',
        start: 'Старт',
        pause: 'Пауза',
        resume: 'Продолжить',
        next: 'Следующий шаг',
        reset: 'Сбросить',
        minutes: '{count} мин',
        progress: 'Шаг {current} из {total}',
        done: 'Все шаги сделаны',
        doneText: 'Отличная работа. Можно отдохнуть.',
      },
      ai: {
        generating: 'Разбиваю задачу…',
        fallbackNotice: 'AI-разбивка недоступна — показан типовой план. Попробуйте ещё раз.',
      },
      camera: {
        title: 'Камера и эмоциональная динамика',
        text: 'Фронтальная камера включается только после вашего разрешения. Пока она включена, кадры уходят в ядро Razuma для анализа динамики.',
        consent: 'Разрешаю доступ к камере',
        enable: 'Включить камеру',
        asking: 'Запрос доступа…',
        disable: 'Выключить камеру',
        capture: 'Проверить кадр',
        analyze: 'Анализировать кадр',
        analyzing: 'Анализирую кадр…',
        measuring: 'Замер…',
        live: 'Живой просмотр · без записи',
        off: 'Камера выключена',
        frameReady: 'Кадр доступен: {width} × {height}',
        frameNone: 'Кадр ещё не сделан',
        auto: 'Измерять во время сессии',
        autoHint: 'Пока камера включена, кадр уходит в ядро с выбранной частотой.',
        frequency: 'Частота замеров',
        seconds: 'каждые {n} с',
        dynamic: 'Эмоциональная динамика',
        dynamicCount: 'Эмоциональная динамика · ответов: {count}',
        dynamicEmpty: 'Проверьте кадр — и здесь появится динамика.',
        engineNote: 'Кадр уходит в существующее ядро Razuma: анализ эмоциональных показателей и их динамики.',
        previewAria: 'Предпросмотр фронтальной камеры',
        frameAlt: 'Проверенный кадр',
        captureHint: 'Подождите, пока камера покажет изображение.',
        play: 'Коснитесь изображения камеры, чтобы запустить просмотр.',
        noCamera: 'Этот браузер не даёт доступ к камере. Откройте страницу в Safari или Chrome.',
        denied: 'Доступ к камере не разрешён. Можно продолжить без камеры.',
        notFound: 'Камера не найдена. Можно продолжить без камеры.',
        unavailable: 'Камера недоступна или занята. Попробуйте снова.',
        streamEnded: 'Поток камеры прервался. Повторите подключение.',
        sessionError: 'Не удалось открыть сессию анализа.',
        error: 'Не удалось проанализировать кадр. Попробуйте ещё раз.',
      },
      emotion: {
        numa: 'Нума',
        core: 'Ответ ядра Razuma',
        offersLabel: 'Мягкие предложения',
        offersHint: 'По устойчивому сочетанию эмоций. Включаете только вы; помощь по запросу работает всегда.',
        baselineTitle: 'Исходный период',
        baselineCollecting: 'Собираю ваш обычный уровень: смотрите спокойно, без выраженных эмоций. Валидных кадров — {valid}, покрытие {coverage}%.',
        baselineReady: 'Исходный уровень можно подтвердить — он станет личным ориентиром этой сессии.',
        baselineConfirm: 'Подтвердить исходный период',
        baselineConfirmed: 'Исходный период подтверждён. Дальше сравниваю с ним.',
        baselineExpressive: 'Исходный период выглядит выразительным. Я возьму самые спокойные кадры как ориентир, но точнее — переснять период со спокойным лицом.',
        baselineReset: 'Переснять исходный период',
        noSignal: 'Пока не хватает валидных кадров. Смотрите в камеру при обычном свете.',
        idle: 'Наблюдаю динамику. Это приглашение к разговору, а не оценка концентрации.',
        quiet: 'Устойчивого сочетания нет — Нума сохраняет тишину.',
        motionLabel: 'Показывать жесты Нумы',
        soundLabel: 'Звуковые сигналы',
        soundVolume: 'Громкость',
        previewTu: 'Прослушать «ту»',
        previewTuDu: 'Прослушать «ту-ду»',
        previewGestures: 'Проверить жесты Нумы',
        gestureCheck: 'Проверка',
        gestureHelp: 'Помощь',
        gestureSupport: 'Поддержка',
        gesturePoint: 'Напоминание',
        requestHelp: 'Запросить помощь',
        answerCount: 'Ответов записано: {count}',
        smallerHint: 'Оставьте только первое действие этого шага.',
        note: 'Показатели приведены адаптером к единой шкале (валентность −1…1; активация, интенсивность и категории 0…1) относительно вашего подтверждённого исходного периода. Формулы — гипотеза для проверки, а не валидированный детектор внимания.',
      },
      action: {
        continue: 'Продолжить',
        helpReturn: 'Помоги вернуться',
        showAction: 'Показать',
        showActionLong: 'Показать текущее действие',
        help: 'Нужна помощь',
        pause: 'Сделать паузу',
        split: 'Разбить на шаги',
        useSteps: 'Использовать эти шаги',
        edit: 'Изменить',
        back: 'Назад',
        resume: 'Вернуться к задаче',
      },
      intervention: {
        continueSelf: 'Продолжить самостоятельно',
        continueWork: 'Продолжить работу',
        check: { message: 'Ты сейчас в задаче?', continue: 'Да, продолжаю' },
        help: { message: 'Нужна помощь с текущим действием?' },
        support: { message: 'Как тебе удобнее продолжить?' },
        point: { message: 'Напомнить текущее действие?' },
        action: { message: 'Текущее действие — {action}.' },
        helpMenu: { message: 'Что поможет продолжить?' },
        steps: { message: 'Предлагаю такие шаги:' },
        pause: { message: 'Пауза. Можно вернуться в любой момент.' },
        done: {
          message: 'Готово. Следующее действие — {action}.',
          allDone: 'Задача завершена',
        },
        unavailable: { message: 'Анализ временно недоступен.' },
      },
      diag: {
        gate: 'Условия показа',
        cameraOff: 'камера выключена',
        noStep: 'нет активного шага',
        notRunning: 'сессия не запущена (нажмите «Старт»)',
        offersOff: 'мягкие предложения выключены',
        enableOffers: 'Включить мягкие предложения',
        baseline: 'собираю исходный период: валидных кадров {valid}, покрытие {coverage}%',
        baselineReady: 'исходный период готов — нажмите «Подтвердить исходный период»',
        ready: 'всё готово — жду устойчивого сочетания',
      },
      reason: {
        waiting: 'ещё нет данных',
        'outside-session': 'вне сессии',
        'no-step': 'нет шага',
        'not-working': 'сессия на паузе',
        'preferences-off': 'предложения выключены',
        'adapter-unverified': 'адаптер не подтверждён',
        'repetition-limit': 'лимит: 5 мин / 2 за сессию',
        'baseline-required': 'нужен исходный период',
        'insufficient-signal': 'мало валидных данных',
        'emotion-only': 'устойчивого сочетания нет',
        'emotion-pattern': 'шаблон сработал',
      },
      how: {
        title: 'Как это работает',
        text: 'Экран открыт, камера доступна, решение за вами. Эмоциональная динамика помогает начать разговор, а не доказывает потерю фокуса.',
      },
      privacy: 'AI-разбивка получает только текст задачи и длительность блока. Кадры с камеры уходят в ядро Razuma для анализа динамики и не записываются.',
    },
    home: {
      title: 'Razuma – флагманская ИИ-платформа для комплексного анализа эмоций по фото и видео',
      description: 'Razuma – это ИИ модель анализа эмоций потребителей: быстро, точно, без личного присутствия.',
      platformUsage: 'Платформа Razuma применяется в различных сферах:',
      features: {
        promo: 'Анализ промо-роликов и A/B-тестирование креативов',
        ux: 'Продуктовое и UX тестирование',
        experience: 'Глубокая оценка эмоционального восприятия клиентского опыта',
        presentations: 'Оценка эффективности выступлений и презентаций',
        scripts: 'Редактирование сценариев для повышения эмоционального отклика',
      },
      analyzeNow: 'Анализировать сейчас',
      learnMore: 'Узнать больше',
    },
    landing: {
      heroTitle: 'Технология,\nкоторая помогает\nвидеть больше',
      heroLead: 'ИИ-платформа анализа состояния и реакций человека по видео и голосу.',
      tryDemo: 'Попробуйте демо',
      discussPilot: 'Обсудить пилот: info@razuma.tech',
      industriesLabel: 'Отрасли',
      analysis: {
        title: 'RÁZUMA анализирует не только то, что человек говорит',
        cards: [
          {
            title: 'Видео',
            items: [
              'Мимические реакции',
              'Интенсивность и динамика эмоций',
              'Изменение эмоционального состояния во времени',
            ],
          },
          {
            title: 'Голос',
            items: [
              'Темп речи',
              'Паузы',
              'Интонационная динамика',
              'Эмоциональная окраска',
              'Изменение голосовых характеристик',
            ],
          },
          {
            title: 'Совместный анализ',
            items: [
              'Динамика показателей во времени',
              'Согласованность сигналов',
              'Изменения относительно обычного состояния',
              'Эпизоды, требующие дополнительного внимания',
              'Часть показателей — в процессе обучения',
            ],
          },
        ],
      },
      industries: {
        title: 'Где уже используют',
        link: 'Все отрасли',
        cards: [
          {
            title: 'HR',
            alt: 'HR и работа с сотрудниками',
            headline: 'Раньше замечать изменение состояния сотрудников',
            bullets: [
              'Регулярная оценка состояния',
              'HR-опросы и интервью',
              'Профилактика выгорания',
              'Оценка команд с высокой нагрузкой',
            ],
          },
          {
            title: 'Промышленность',
            alt: 'Промышленность и предсменный контроль',
            headline: 'Дополнительный сигнал риска перед работой',
            bullets: [
              'Предсменный контроль',
              'Оценка уровня внимания',
              'Профилактика инцидентов',
              'Снижение человеческого фактора',
            ],
          },
          {
            title: 'Банки',
            alt: 'Банки и безопасность клиентов',
            headline: 'Выявление возможного внешнего воздействия',
            bullets: [
              'Нетипичные операции',
              'Взаимодействие с клиентом',
              'Дополнительная проверка',
              'Больше уверенности в безопасности клиентов',
            ],
          },
          {
            title: 'Маркетинговые исследования',
            alt: 'Маркетинговые исследования',
            headline: 'Настоящие реакции — более точные инсайты',
            bullets: [
              'Тестирование рекламы',
              'Концепт- и продукт-тесты',
              'Глубинные интервью',
              'UX/CX-исследования',
              'Customer Journey',
            ],
          },
        ],
      },
      benefits: {
        cards: [
          {
            title: 'Ранний сигнал',
            text: 'Возможность действовать до того, как проблема проявилась в результате.',
          },
          {
            title: 'Дополнительный слой данных',
            text: 'Не только слова и анкеты, но и реальная динамика поведения.',
          },
          {
            title: 'Динамика, а не единичная оценка',
            text: 'Можно отслеживать изменения во времени.',
          },
          {
            title: 'Интеграция в ваши процессы',
            text: 'RÁZUMA дополняет существующие процессы и не заменяет решения специалистов.',
          },
        ],
      },
      decision: 'RÁZUMA помогает принимать решения,\nа не принимает их вместо заказчика.',
      contactsLabel: 'Контакты RÁZUMA',
      security: {
        title: 'Безопасность данных',
        cards: [
          {
            icon: '🔒',
            title: 'Шифрование данных',
            text: 'Все данные передаются и хранятся в зашифрованном виде. Используются современные протоколы шифрования, соответствующие стандартам индустрии.',
          },
          {
            icon: '🏢',
            title: 'Локальная обработка',
            text: 'Возможность развернуть платформу в контуре заказчика. Видео- и аудиоданные не покидают вашу инфраструктуру.',
          },
          {
            icon: '🛡',
            title: 'Обезличивание',
            text: 'RÁZUMA анализирует паттерны поведения, а не идентифицирует личность. Биометрические данные не сохраняются и не передаются третьим лицам.',
          },
          {
            icon: '📋',
            title: 'Соответствие 152-ФЗ',
            text: 'Обработка данных соответствует требованиям Федерального закона № 152-ФЗ «О персональных данных» и рекомендациям регуляторов.',
          },
          {
            icon: '✓',
            title: 'Контроль доступа',
            text: 'Гибкая система ролей и разграничения доступа. Каждый пользователь видит только те данные, которые разрешены его ролью.',
          },
          {
            icon: '⏱',
            title: 'Политика хранения',
            text: 'Настраиваемые сроки хранения данных. Автоматическое удаление записей по истечении заданного периода в соответствии с политикой компании.',
          },
        ],
      },
      cta: {
        demoTitle: 'Попробуйте технологию\nв действии',
        demoText: 'Загрузите пример видео или аудио и получите пример анализа.',
        demoBtn: 'Попробуйте демо',
        contactTitle: 'Обсудим, как RÁZUMA\nможет работать в вашей компании',
        contactText: 'Расскажите о вашей задаче — и мы предложим оптимальный сценарий внедрения.',
        contactBtn: 'Обсудить пилот: info@razuma.tech',
      },
    },
    features: {
      title: 'Возможности Razuma',
      main: 'Ключевые возможности платформы',
      cards: [
        'Анализ эмоций по фото, видео и аудио в реальном времени',
        'A/B-тестирование креативов для маркетинга и рекламы',
        'Оценка эмоционального восприятия пользовательского опыта (UX)',
        'Анализ эффективности презентаций и публичных выступлений',
        'Оптимизация сценариев для повышения эмоционального отклика',
        'API-интеграция с вашими CRM и бизнес-системами',
        'Расширенная аналитика и персональные экспертные отчеты'
      ],
      clients: {
        title: 'Кому подходит Razuma',
        b2b: 'Крупный бизнес, агентства, исследовательские центры',
        b2c: 'Малый и средний бизнес, стартапы, фрилансеры'
      }
    },
    pricing: {
      title: 'Тарифы',
      free: {
        name: 'Free',
        price: 'Бесплатно',
        features: [
          'Анализ 3-х фото в месяц',
          'До 30 секунд видео или аудио в месяц',
        ],
      },
      light: {
        name: 'Light',
        price: '9 990 ₽/мес',
        features: [
          'Ведение до 10 проектов',
          'Неограниченный анализ фото',
          'До 2 часов видео и аудио',
          'Проведение A/B-анализа',
          'Полный API-доступ',
        ],
      },
      pro: {
        name: 'Pro',
        price: '29 990 ₽/мес',
        features: [
          'Неограниченное количество проектов',
          'Анализ любого количества фото, видео и аудио',
          'Проведение A/B-анализа',
          'Полный API-доступ',
          'Расширенная аналитика и техподдержка',
          'Персональные экспертные отчеты',
        ],
      },
      business: {
        name: 'Business',
        price: 'По запросу',
        features: [
          'Неограниченное количество проектов',
          'Анализ любого количества фото, видео и аудио',
          'Проведение A/B-анализа',
          'Полный API-доступ',
          'Расширенная аналитика и техподдержка',
          'Персональные экспертные отчеты',
          'Внедрение в CRM',
        ],
      },
      usePlan: 'Использовать',
      applyPlan: 'Отправить заявку',
    },
      contact: {
      title: 'Контактная информация',
      legalInfo: 'Юридическая информация',
      companyNameLabel: 'Наименование компании',
      companyName: 'ООО "Разумные Технологии"',
      legalAddressLabel: 'Юридический адрес',
      legalAddress: 'Москва, тер. Инновационного Центра Сколково, Большой б-р, д. 42 стр. 1',
      inlnLabel: 'ИНН',
      inln: '9731157733',
      ogrnipLabel: 'ОГРНИП',
      ogrnip: '1257700507745',
      contactDetails: 'Контактные данные',
      emailLabel: 'Email',
      email: 'info@razuma.tech',
      phoneLabel: 'Телефон',
      phone: '+7 (961) 063-67-71',
      workingHoursLabel: 'Режим работы',
      workingHours: 'Пн-Пт: 10:00 - 19:00 (МСК)'
    },
    detector: {
      heroTagline: 'ТЕХНОЛОГИИ. ЛЮДИ. РЕШЕНИЯ.',
      heroTitle: 'Попробуйте демо RÁZUMA',
      heroLead: 'Оцените возможности нашей платформы и узнайте, как ИИ помогает видеть больше в эмоциях, поведении и реакции человека.',
      panelInstruction: 'Загрузите ваш файл аудио, видео или фото и выберите режим обработки.',
      benefits: {
        fastTitle: 'Быстрая загрузка',
        fastText: 'Поддерживаем основные форматы фото, аудио и видео.',
        modeTitle: 'Выбор режима',
        modeText: 'Используйте готовые сценарии анализа под ваши задачи.',
        resultTitle: 'Результат анализа',
        resultText: 'Получите детальный анализ и ценные инсайты.',
      },
      dragFile: 'Перетащите файл сюда',
      chooseFile: 'Выбрать файл',
      supportedFormats: 'JPG, PNG, MP4, AVI, WEBM, MP3, WAV, AAC, OGG, FLAC (макс. 50 МБ)',
      consent: 'Я даю согласие на обработку моих персональных данных в соответствии с',
      analyze: 'Анализ',
      processingMode: 'Режим обработки',
      modes: {
        standard: 'Стандартный анализ',
        burnout: 'Анализ состояния человека',
        externalInfluence: 'Анализ внешнего влияния',
      },
      processing: 'Обработка...',
      complete: 'Анализ завершен',
      framesProcessed: 'Обработано кадров: {count}',
      frame: 'Кадр',
      frames: 'Кадры',
      noImage: 'Нет изображения',
      videoAnalysisComplete: 'Анализ видео завершен',
      selectedFile: 'Выбранный файл',
      imageAnalysis: 'Анализ изображения',
      audioAnalysis: 'Анализ аудио',
      audioBurnoutAnalysis: 'Анализ выгорания по аудио',
      mainEmotion: 'Основная эмоция',
      detectedEmotions: 'Обнаруженные эмоции',
      averageEmotions: 'Средние эмоции',
      emotionTimeline: 'График эмоций',
      features: {
        title: 'Валентность / Возбуждение',
        valence: 'Валентность',
        arousal: 'Возбуждение',
      },
      duration: 'Длительность',
      sampleRate: 'Частота дискретизации',
      noBurnoutData: 'Нет данных анализа выгорания.',
      analysisResults: 'Результаты анализа',
      startingProcessing: 'Начало обработки...',
      processingAudio: 'Обработка аудио...',
      processingVideo: 'Обработка видео...',
      processingImage: 'Обработка изображения...',
      processingComplete: 'Обработка завершена!',
      burnoutComplete: 'Анализ выгорания завершен',
      externalInfluenceComplete: 'Анализ внешнего влияния завершен',
      fileProcessing: 'Обработка файла...',
      processingFrame: 'Обработка кадра {current} из {total}',
      processingSegment: 'Обработка сегмента {current} из {total}',
    },
    emotions: {
      anger: 'Гнев',
      contempt: 'Презрение',
      disgust: 'Отвращение',
      fear: 'Страх',
      neutral: 'Нейтрально',
      happiness: 'Радость',
      surprise: 'Удивление',
      sadness: 'Грусть',
      valence: 'Валентность',
      arousal: 'Интенсивность',
    },
    burnout: {
      title: 'Анализ риска профессионального выгорания',
      low: 'Низкий риск',
      moderate: 'Умеренный риск',
      high: 'Высокий риск',
      severe: 'Очень высокий риск',
      score: 'Уровень риска',
      confidence: 'Надёжность оценки',
      topFactor: 'Основной выявленный сигнал',
      recommendations: 'Действия менеджера',
      disclaimer:
        'Результат основан на автоматическом анализе речевых характеристик и, при наличии данных, их динамики. Он не является медицинским диагнозом и не может использоваться как единственное основание для оценки эффективности, дисциплинарных мер или других кадровых решений.',
      state: 'Результат анализа',
      componentAnalysis: 'Из чего складывается оценка',
      error: 'Не удалось выполнить анализ',
      basis: 'На основании чего сделан вывод',
      conclusion: 'Оценка состояния',
      action: 'Рекомендации',
      urgency: 'Срочность и дальнейшие действия',
      factorExplanation: 'Пояснение',
      requiresHistory: 'требуется несколько записей',
      importantNote: 'Важно знать',

      attentionLevel: {
        title: 'Уровень внимания',
        mainSignal: 'Основной сигнал',
        low: 'Низкий',
        moderate: 'Умеренный',
        high: 'Высокий',
        severe: 'Очень высокий',
        noSignals: 'Выраженных сигналов не выявлено',
      },

      components: {
        exhaustion: 'Эмоциональное истощение',
        prosodicFlattening: 'Изменение интонационной выразительности',
        pauseTempo: 'Изменение темпа речи и паузы',
        negativeActivation: 'Эмоциональное напряжение',
        positiveAffectLoss: 'Снижение положительной эмоциональной окраски',
      },

      states: {
        normal: 'Стабильное состояние',
        shortStress: 'Кратковременное напряжение',
        sustainedStress: 'Повышенное напряжение',
        burnoutLike: 'Состояние, похожее на выгорание',
        lowAffect: 'Сниженная эмоциональная выразительность',
        insufficientData: 'Недостаточно данных',
      },

      factors: {
        'Positive Affect Loss': 'Потеря положительного аффекта',
        'Negative Activation': 'Негативная активация',
        'Prosodic Flattening': 'Просодическое уплощение',
        'Pause/Tempo Changes': 'Изменения пауз/темпа',
        'Emotional Exhaustion': 'Эмоциональное истощение',
      },

      basisText: {
        normal:
          'Показатели энергии, эмоционального напряжения, интонационной выразительности, темпа речи и пауз находятся в нормальном диапазоне. Если есть предыдущие записи, отрицательной динамики не выявлено.',
        shortStress:
          'В текущей записи выявлены отдельные изменения: усиление эмоционального напряжёния, изменение темпа или пауз либо снижение эмоциональной выразительности. Данных о повторяемости этих изменений пока нет.',
        sustainedStress:
          'Изменения затрагивают несколько групп показателей и повторяются в нескольких сопоставимых записях: сохраняется напряжённая эмоциональная окраска, меняются темп и паузы, снижается положительная эмоциональная выразительность или появляются признаки снижения энергии.',
        burnoutLike:
          'В нескольких записях сохраняется сочетание выраженных изменений: признаки снижения энергии, уменьшение эмоциональной выразительности, снижение положительной эмоциональной окраски, напряжённый эмоциональный фон и изменения темпа речи или пауз.',
        lowAffect:
          'В речи выявлено снижение интонационного разнообразия и положительной эмоциональной окраски. Других признаков недостаточно, чтобы сделать вывод об устойчивом стрессе или выгорании.',
        insufficientData:
          'Запись слишком короткая, содержит недостаточно речи, посторонние шумы или технические искажения. Либо для оценки динамики недостаточно предыдущих записей.',
        default: 'Недостаточно данных для надёжного вывода.',
      },

      conclusionText: {
        normal:
          'Значимых признаков риска не выявлено. На момент записи выраженных признаков повышенного стресса или эмоционального истощения не обнаружено.',
        shortStress:
          'Выявлены признаки кратковременного напряжения. Результат может отражать реакцию на срочную задачу, сложный разговор, высокую нагрузку, усталость или недосып. Он не указывает на сформировавшееся выгорание.',
        sustainedStress:
          'Выявлены признаки устойчивого напряжения. Динамика может свидетельствовать о продолжительной рабочей нагрузке и недостаточном восстановлении. Это не означает выгорание, но указывает на повышенный риск его развития.',
        burnoutLike:
          'Выявлены признаки, совместимые с профессиональным выгоранием. Результат требует внимания, но не является диагнозом и не позволяет автоматически определить причину состояния.',
        lowAffect:
          'Выявлена сниженная эмоциональная выразительность. Причиной могут быть усталость, смена настроения, содержание разговора, индивидуальная манера речи или условия записи. Результат не означает низкой мотивации, безразличия или нелояльности.',
        insufficientData:
          'Недостаточно данных для надёжного вывода. Результат анализа и уровень риска не определены.',
        default: 'Недостаточно данных для вывода.',
      },

      urgencyText: {
        low: 'Низкий риск. Выраженного сочетания неблагоприятных сигналов не выявлено. Специальные меры не требуются. Продолжайте плановое наблюдение.',
        moderate:
          'Умеренный риск. Выявлены отдельные изменения, которые могут быть связаны с повышенной нагрузкой или недостаточным восстановлением. В ближайшие несколько рабочих дней проведите короткую конфиденциальную беседу. Уточните нагрузку и согласуйте одну–две профилактические меры. Повторите оценку через 7–14 дней.',
        high: 'Высокий риск. Выявлено сочетание нескольких выраженных или повторяющихся сигналов, требующих внимания руководителя. Свяжитесь с сотрудником в ближайший рабочий день. Обсудите нагрузку, сроки, переработки и необходимую поддержку. После принятых мер проверьте динамику.',
        severe:
          'Очень высокий риск — требуется повышенное внимание к состоянию сотрудника. Совокупность сигналов достигла верхнего порога риска. Свяжитесь с сотрудником в тот же рабочий день. Уточните самочувствие и возможность продолжать текущую работу, проверьте нагрузку. По возможности снимите необязательные срочные задачи и предложите корпоративные ресурсы поддержки.',
        default: 'Уровень риска не определён.',
      },

      factorExplanations: {
        positive_affect_loss:
          'Снижение положительной эмоциональной окраски. В речи стало меньше признаков положительной эмоциональной вовлечённости. Это не означает автоматически потерю мотивации, снижение лояльности или ухудшение качества работы.',
        negative_activation:
          'Повышенный уровень напряжения. В речи выявлена усиленная напряжённая или негативная эмоциональная окраска. Система фиксирует изменение, но не определяет его причину.',
        prosodic_flattening:
          'Изменение интонационной выразительности. Интонационное разнообразие речи заметно отличается от обычного для сотрудника — как в сторону снижения, так и в сторону усиления. Это может быть связано с усталостью, напряжением, содержанием разговора, индивидуальной манерой речи или условиями записи.',
        'pause/tempo_changes':
          'Изменение темпа речи и пауз. Темп или продолжительность пауз отличаются от ожидаемого паттерна. Возможные причины включают усталость, высокую умственную нагрузку, сложность обсуждаемой темы или технические особенности записи.',
        emotional_exhaustion:
          'Признаки снижения энергии. В речи выявлено сочетание характеристик, которое может наблюдаться при усталости и недостаточном восстановлении. Вывод необходимо сопоставлять с рабочей нагрузкой и динамикой предыдущих записей.',
      },

      recommendationsList: {
        severe_risk_immediate_action: '⚠️ Очень высокий риск — требуется немедленное внимание',
        contact_employee_same_day: 'Свяжитесь с сотрудником в тот же рабочий день',
        check_wellbeing_and_workload: 'Уточните самочувствие и возможность продолжать текущую работу',
        remove_non_urgent_tasks: 'По возможности снимите необязательные срочные задачи',
        offer_support_resources: 'Предложите корпоративные ресурсы поддержки',
        high_risk_contact_supervisor: 'Свяжитесь с сотрудником в ближайший рабочий день',
        discuss_workload_and_deadlines: 'Обсудите нагрузку, сроки, переработки и необходимую поддержку',
        check_dynamics_after_actions: 'После принятых мер проверьте динамику',
        moderate_risk_preventive_measures:
          'Выявлены отдельные признаки повышенной нагрузки. Рекомендуются профилактические меры и наблюдение за динамикой.',
        discuss_workload_with_supervisor:
          'Проведите конфиденциальную беседу о текущей нагрузке, сроках, приоритетах и переработках.',
        schedule_regular_breaks:
          'Обсудите с сотрудником возможность регулярных перерывов и восстановления в течение рабочего дня.',
        repeat_assessment_7_14_days: 'Повторите оценку через 7–14 дней.',
        normal_emotional_state_detected:
          'Значимых признаков повышенного эмоционального напряжения не выявлено.',
        no_additional_measures: 'Дополнительные меры не требуются.',
        maintain_balanced_schedule: 'Рекомендуется сохранять сбалансированный режим работы и восстановления.',
        regular_check_ups: 'Следующую оценку рекомендуется провести по установленному графику наблюдения.',
        emotional_exhaustion_detected:
          'Признаки снижения энергии. Рекомендуется обратить внимание на режим работы и восстановления.',
        voice_monotony_detected:
          'Выявлено изменение интонационной выразительности речи относительно обычного для сотрудника. Этот показатель следует оценивать только вместе с другими сигналами и динамикой предыдущих записей.',
        speech_pattern_changes:
          'Выявлены изменения темпа речи или пауз. Уточните контекст записи и повторите оценку в сопоставимых условиях.',
        high_negative_activation:
          'Выявлен повышенный уровень напряжения. Рекомендуется обсудить возможные источники стресса.',
        reduced_positive_affect:
          'Выявлено снижение положительной эмоциональной окраски речи. Это неспецифический сигнал, который не следует интерпретировать как потерю мотивации или лояльности.',
        analysis_failed_retry: '⚠️ Ошибка анализа. Пожалуйста, попробуйте снова.',
      },

      comments: {
        need_history_to_distinguish_short_vs_chronic:
          'Без истории нескольких текущих записей нельзя надежно различить кратковременное напряжение и хроническое выгорание.',
        need_dynamics_for_sustained_stress:
          'Для разграничения кратковременного напряжения и устойчивого риска необходима динамика нескольких сопоставимых записей.',
        burnout_compatible_not_diagnosis:
          'Результат совместим с профессиональным выгоранием, но не является диагнозом.',
        low_affect_nonspecific_signal:
          'Сниженная эмоциональная выразительность — неспецифический сигнал, требующий сопоставления с контекстом.',
        'без_истории_нескольких_текущих_записей_нельзя_надежно_различить_short_stress_vs_chronic_burnout':
          'Для разграничения кратковременного напряжения и устойчивого риска необходима динамика нескольких сопоставимых записей. По одной записи нельзя надёжно сделать вывод о хроническом стрессе или признаках профессионального выгорания.',
      },

      errors: {
        analysis_failed: 'Не удалось выполнить анализ. Пожалуйста, попробуйте снова.',
      },
    },
    externalInfluence: {
      title: 'Сигнал возможного внешнего воздействия',
      subtitle: 'Антифрод-ориентир по аудиозаписи разговора (пилот)',
      score: 'Индекс выраженности сигнала',
      scoreHint: 'Не является вероятностью мошенничества.',
      quality: 'Качество аудио',
      persistentPattern: 'Устойчивое сочетание признаков',
      contextConfirmed: 'Подтверждено контекстными признаками',
      topFactors: 'Ключевые сигналы',
      componentsTitle: 'Из чего складывается оценка',
      fragmentTimeline: 'Оценки по фрагментам разговора',
      fragmentLabel: 'Фрагмент {n}',
      contextApplied: 'Контекстные признаки (учтены при расчёте)',
      managerAction: 'Действие менеджера',
      importantNote: 'Важно знать',
      disclaimer:
        'Результат — пилотный сигнал возможного внешнего воздействия на сотрудника. Он не является доказательством мошенничества, не определяет виновность и сам по себе не должен блокировать операции или служить единственным основанием для решений.',

      states: {
        insufficientData: 'Недостаточно данных для оценки',
        low: 'Выраженных признаков не выявлено',
        elevatedTension: 'Повышенное напряжение',
        possiblePressure: 'Возможное внешнее давление',
        probableInfluence: 'Вероятное внешнее воздействие',
        highRisk: 'Высокий риск внешнего воздействия',
      },

      explanationLabel: 'Пояснение',

      stateExplanations: {
        low: 'Выраженных изменений эмоционального состояния и речевого поведения по голосовому сигналу не выявлено. Это не исключает воздействие, которое не проявилось в голосе.',
        elevatedTension:
          'Выявлены изменения эмоционального состояния и речевого поведения. Причина изменений по голосовому сигналу не определяется.',
        possiblePressure:
          'Выявлены отдельные изменения эмоционального состояния и речевого поведения, возможные при внешнем давлении. Сами по себе они не являются признаком мошенничества.',
        probableInfluence:
          'Изменения эмоционального состояния и речевого поведения устойчивы и сочетаются с признаками, характерными для внешнего воздействия. Причина изменений по голосовому сигналу однозначно не определяется.',
        highRisk:
          'Выявлено устойчивое сочетание выраженных изменений и признаков, характерных для внешнего воздействия. Результат — пилотный сигнал и не является доказательством мошенничества.',
      },

      factors: {
        'NEGATIVE_ACTIVATION_HIGH': 'Повышенное эмоциональное напряжение',
        'PAUSE_TEMPO_DEVIATION': 'Отклонение темпа речи и пауз',
        'PROSODIC_DEVIATION': 'Отклонение интонационной выразительности',
        'POSITIVE_AFFECT_LOSS_HIGH': 'Снижение положительной эмоциональной окраски',
        'PERSISTENT_PATTERN': 'Устойчивое сочетание признаков (не менее 2 из 3 фрагментов)',
        'CONTEXT_CONFIRMED': 'Подтверждено контекстными признаками',
      },

      actions: {
        'STANDARD_PROCESS': 'Обрабатывать в стандартном порядке',
        'CONTINUE_NO_BLOCK': 'Продолжить без блокировки',
        'ASK_CONTROL_QUESTIONS': 'Задать контрольные вопросы',
        'ENHANCED_ANTIFRAUD_CHECK': 'Провести усиленную антифрод-проверку',
        'PRIORITY_ANTIFRAUD_REVIEW': 'Провести приоритетную антифрод-проверку',
      },

      components: {
        negativeActivation: 'Эмоциональное напряжение',
        pauseTempoDeviation: 'Темп речи и паузы',
        prosodicDeviation: 'Интонационная выразительность',
        positiveAffectLoss: 'Положительная эмоциональная окраска',
      },

      context: {
        'THIRD_PARTY_INSTRUCTIONS': 'Слышны инструкции третьих лиц',
        'COACHED_ANSWERS': 'Подсказанные ответы',
        'COVER_STORY': 'Легенда / прикрытие',
        'AUDIBLE_THIRD_PARTY_PROMPT': 'Слышны подсказки третьего лица',
        'URGENCY': 'Давление по времени / срочность',
        'SECRECY': 'Требование секретности',
        'SAFE_ACCOUNT': 'Упоминание «безопасного счёта»',
        'AUTHORITY_IMPERSONATION': 'Имитация авторитета (руководство, банк)',
        'PURPOSE_INCONSISTENCY': 'Несоответствие цели звонка',
        'UNKNOWN_PAYEE': 'Неизвестный получатель перевода',
        'EXTERNAL_CALL_IN_PROGRESS': 'Идёт внешний звонок / перевод разговора',
      },

      guidance: {
        insufficientData:
          'Недостаточно данных: запись короче 30 секунд осмысленной речи, низкое качество аудио или низкая надёжность оценки. Загрузите более длинную и чистую запись разговора.',
        noResult: 'Результат недоступен.',
      },

      reasons: {
        lowAudioQuality: 'Причина: качество аудио ниже порога — запись слишком тихая, шумная или без речи.',
        tooFewFragments: 'Причина: менее 3 валидных фрагментов — слишком короткая или прерывистая запись.',
        noValidFragments: 'Причина: ни один фрагмент не удалось сопоставить с базовым профилем.',
        lowConfidence: 'Причина: надёжность оценки ниже порога достоверности (обычно малый объём распознанной речи или слабый сигнал модели).',
      },
    },
    footer: {
      copyright: '© 2026 RÁZUMA',
    },
    cookies: {
      text: 'Мы используем файлы cookie для улучшения работы сайта.',
      more: 'Подробнее',
      accept: 'Принять',
    },
    modal: {
      title: 'Отправить заявку',
      name: 'Имя*',
      phone: 'Телефон*',
      company: 'Название компании',
      submit: 'Отправить заявку',
      submitting: 'Отправка...',
    },
    errors: {
      fileNotSelected: 'Файл не выбран',
      consentRequired: 'Необходимо дать согласие на обработку данных',
      unsupportedFormat: 'Неподдерживаемый формат файла',
      fileTooLarge: 'Файл слишком большой',
      uploadFailed: 'Не удалось загрузить файл',
      progressCheckFailed: 'Не удалось проверить ход обработки',
      processingTimeout: 'Обработка заняла слишком много времени',
      processingFailed: 'Не удалось выполнить обработку',
      networkError: 'Ошибка сети',
    },
  },
  en: {
    common: {
      processing: 'Processing...',
      analyze: 'Analyze',
      cancel: 'Cancel',
      close: 'Close',
      clear: 'Clear',
      or: 'or',
      error: 'Error',
      success: 'Success',
      loading: 'Loading...',
      showRawData: 'Show raw data',
    },
    nav: {
      features: 'Features',
      demo: 'Demo',
      privacy: 'Privacy',
      contacts: 'Contacts',
      tryDemo: 'Try Demo',
      solutions: 'Solutions',
      industries: 'Industries',
      security: 'Security',
      technology: 'Technology',
      cases: 'Cases',
      about: 'About us',
      contactUs: 'Contact us',
      focus: 'Focus',
    },
    focus: {
      badge: 'Private beta',
      kicker: 'Razuma Focus — your place to work',
      title: 'At your own pace. One task. One manageable step.',
      subtitle: 'Numa is nearby when you need help.',
      tabs: {
        movement: 'Movement',
        session: 'My session',
        how: 'How it works',
      },
      movement: {
        title: 'Movement',
        prompt: 'What would you like to move forward?',
        hint: 'Let us pick one small action.',
        placeholder: 'Describe the task in your own words…',
        generate: 'Break down the task',
        regenerate: 'Rebuild the plan',
      },
      presets: {
        presentation: 'Prepare a presentation',
        letter: 'Write a letter',
        study: 'Prepare for study',
      },
      plan: {
        heading: 'Your step-by-step plan',
        count: 'Steps: {count}',
        addStep: 'Add a step',
        remove: 'Remove step',
        empty: 'Describe a task and a step-by-step plan will appear.',
        manual: 'New step',
        timeLimit: 'Limit the time',
        blockDuration: '25 minutes',
        numaNearby: 'Numa is nearby',
        prepare: 'Prepare the session',
        steps: {
          generic: {
            clarify: 'Clarify exactly what needs to be done',
            plan: 'Outline the smallest first step',
            firstStep: 'Do that step (5–10 minutes)',
            review: 'Look at the result and decide what is next',
          },
          presentation: {
            goal: 'Define the main message',
            structure: 'Sketch the structure',
            draft: 'Put together a draft',
            visual: 'Add a visual accent',
            rehearse: 'Say it out loud',
          },
          letter: {
            goal: 'Understand the purpose of the letter',
            points: 'List the key points',
            draft: 'Write a draft',
            send: 'Review and send',
          },
          study: {
            topic: 'Define the topic and scope',
            materials: 'Gather the materials',
            firstPass: 'Go through the first block',
            selfCheck: 'Check yourself with questions',
          },
        },
      },
      session: {
        title: 'My session',
        text: 'One step at a time. Start the timer and pause whenever you need.',
        start: 'Start',
        pause: 'Pause',
        resume: 'Resume',
        next: 'Next step',
        reset: 'Reset',
        minutes: '{count} min',
        progress: 'Step {current} of {total}',
        done: 'All steps are done',
        doneText: 'Great job. Take a rest.',
      },
      ai: {
        generating: 'Breaking down the task…',
        fallbackNotice: 'AI breakdown is unavailable — showing a standard plan. Please try again.',
      },
      camera: {
        title: 'Camera and emotional dynamics',
        text: 'The front camera starts only after your permission. While it is on, frames go to the Razuma core for dynamics analysis.',
        consent: 'I allow camera access',
        enable: 'Turn on the camera',
        asking: 'Requesting access…',
        disable: 'Turn off the camera',
        capture: 'Check the frame',
        analyze: 'Analyze the frame',
        analyzing: 'Analyzing the frame…',
        measuring: 'Measuring…',
        live: 'Live preview · no recording',
        off: 'Camera is off',
        frameReady: 'Frame available: {width} × {height}',
        frameNone: 'No frame captured yet',
        auto: 'Measure during the session',
        autoHint: 'While the camera is on, a frame goes to the core at the chosen rate.',
        frequency: 'Measurement rate',
        seconds: 'every {n} s',
        dynamic: 'Emotional dynamics',
        dynamicCount: 'Emotional dynamics · answers: {count}',
        dynamicEmpty: 'Check a frame and the dynamics will appear here.',
        engineNote: 'The frame goes to the existing Razuma core: analysis of emotional indicators and their dynamics.',
        previewAria: 'Front camera preview',
        frameAlt: 'Checked frame',
        captureHint: 'Wait until the camera shows an image.',
        play: 'Tap the camera image to start the preview.',
        noCamera: 'This browser does not allow camera access. Open the page in Safari or Chrome.',
        denied: 'Camera access was not granted. You can continue without the camera.',
        notFound: 'No camera found. You can continue without the camera.',
        unavailable: 'The camera is unavailable or busy. Try again.',
        streamEnded: 'The camera stream was interrupted. Reconnect to continue.',
        sessionError: 'Could not open the analysis session.',
        error: 'Could not analyze the frame. Please try again.',
      },
      emotion: {
        numa: 'Numa',
        core: 'Razuma core response',
        offersLabel: 'Gentle offers',
        offersHint: 'Based on a sustained emotion combination. Only you enable it; help on request always works.',
        baselineTitle: 'Baseline period',
        baselineCollecting: 'Collecting your usual level: keep a calm, neutral face. {valid} valid frames, coverage {coverage}%.',
        baselineReady: 'The baseline can be confirmed — it becomes this session’s personal reference.',
        baselineConfirm: 'Confirm the baseline period',
        baselineConfirmed: 'Baseline confirmed. I compare against it from here.',
        baselineExpressive: 'The baseline looks expressive. I will use the calmest frames as the reference, but re-collecting it with a calm face is more accurate.',
        baselineReset: 'Re-collect the baseline',
        noSignal: 'Not enough valid frames yet. Look at the camera in ordinary light.',
        idle: 'Watching the dynamics. This is an invitation to talk, not a focus score.',
        quiet: 'No sustained combination — Numa stays silent.',
        motionLabel: 'Show Numa’s gestures',
        soundLabel: 'Sound cues',
        soundVolume: 'Volume',
        previewTu: 'Preview “tu”',
        previewTuDu: 'Preview “tu-du”',
        previewGestures: 'Preview Numa’s gestures',
        gestureCheck: 'Check',
        gestureHelp: 'Help',
        gestureSupport: 'Support',
        gesturePoint: 'Point',
        requestHelp: 'Request help',
        answerCount: 'Answers recorded: {count}',
        smallerHint: 'Keep only the first action of this step.',
        note: 'The adapter brings the readings to one scale (valence −1…1; activation, intensity and categories 0…1) relative to your confirmed baseline period. The formulas are a hypothesis for testing, not a validated attention detector.',
      },
      action: {
        continue: 'Continue',
        helpReturn: 'Help me return',
        showAction: 'Show',
        showActionLong: 'Show the current action',
        help: 'I need help',
        pause: 'Take a pause',
        split: 'Break into steps',
        useSteps: 'Use these steps',
        edit: 'Edit',
        back: 'Back',
        resume: 'Return to the task',
      },
      intervention: {
        continueSelf: 'Continue on my own',
        continueWork: 'Continue working',
        check: { message: 'Are you still on the task?', continue: 'Yes, continuing' },
        help: { message: 'Need help with the current action?' },
        support: { message: 'How would you prefer to continue?' },
        point: { message: 'Remind the current action?' },
        action: { message: 'Current action — {action}.' },
        helpMenu: { message: 'What would help you continue?' },
        steps: { message: 'Here are the suggested steps:' },
        pause: { message: 'Pause. You can return at any time.' },
        done: {
          message: 'Done. Next action — {action}.',
          allDone: 'The task is complete',
        },
        unavailable: { message: 'Analysis is temporarily unavailable.' },
      },
      diag: {
        gate: 'Show conditions',
        cameraOff: 'camera is off',
        noStep: 'no active step',
        notRunning: 'session not started (press “Start”)',
        offersOff: 'gentle offers are off',
        enableOffers: 'Turn on gentle offers',
        baseline: 'collecting the baseline: {valid} valid frames, coverage {coverage}%',
        baselineReady: 'baseline is ready — press “Confirm the baseline period”',
        ready: 'all set — waiting for a sustained combination',
      },
      reason: {
        waiting: 'no data yet',
        'outside-session': 'outside session',
        'no-step': 'no step',
        'not-working': 'session paused',
        'preferences-off': 'offers are off',
        'adapter-unverified': 'adapter not verified',
        'repetition-limit': 'limit: 5 min / 2 per session',
        'baseline-required': 'baseline required',
        'insufficient-signal': 'not enough valid data',
        'emotion-only': 'no sustained combination',
        'emotion-pattern': 'a pattern fired',
      },
      how: {
        title: 'How it works',
        text: 'The screen is on, the camera is available, the decision is yours. Emotional dynamics help start a conversation, not prove a loss of focus.',
      },
      privacy: 'The AI breakdown receives only the task text and the block duration. Camera frames go to the Razuma core for dynamics analysis and are not recorded.',
    },
    home: {
      title: 'Razuma - flagship AI platform for comprehensive emotion analysis from photos and videos',
      description: 'Razuma is an AI model for consumer emotion analysis: fast, accurate, without personal presence.',
      platformUsage: 'The Razuma platform is used in various areas:',
      features: {
        promo: 'Analysis of promotional videos and A/B testing of creatives',
        ux: 'Product and UX testing',
        experience: 'Deep assessment of emotional perception of customer experience',
        presentations: 'Evaluation of performance and presentation effectiveness',
        scripts: 'Script editing to enhance emotional response',
      },
      analyzeNow: 'Analyze now',
      learnMore: 'Learn more',
    },
    landing: {
      heroTitle: 'Technology that\nhelps you see more',
      heroLead: 'AI platform for analyzing a person’s state and reactions from video and voice.',
      tryDemo: 'Try the demo',
      discussPilot: 'Discuss a pilot',
      industriesLabel: 'Industries',
      analysis: {
        title: 'RÁZUMA analyzes more than just what a person says',
        cards: [
          {
            title: 'Video',
            items: [
              'Facial reactions',
              'Intensity and dynamics of emotions',
              'Changes in emotional state over time',
            ],
          },
          {
            title: 'Voice',
            items: [
              'Speech tempo',
              'Pauses',
              'Intonation dynamics',
              'Emotional coloring',
              'Changes in voice characteristics',
            ],
          },
          {
            title: 'Joint analysis',
            items: [
              'Dynamics of indicators over time',
              'Consistency of signals',
              'Changes relative to the usual state',
              'Episodes requiring additional attention',
              'Some indicators are still in the learning process',
            ],
          },
        ],
      },
      industries: {
        title: 'Where it is already used',
        link: 'All industries',
        cards: [
          {
            title: 'HR',
            alt: 'HR and employee care',
            headline: 'Notice changes in employee state earlier',
            bullets: [
              'Regular state assessment',
              'HR surveys and interviews',
              'Burnout prevention',
              'Assessing high-load teams',
            ],
          },
          {
            title: 'Industry',
            alt: 'Industry and pre-shift control',
            headline: 'An additional risk signal before work',
            bullets: [
              'Pre-shift control',
              'Attention level assessment',
              'Incident prevention',
              'Reducing human factors',
            ],
          },
          {
            title: 'Banks',
            alt: 'Banks and client security',
            headline: 'Identifying possible external influence',
            bullets: [
              'Atypical operations',
              'Interaction with the client',
              'Additional verification',
              'More confidence in client security',
            ],
          },
          {
            title: 'Marketing research',
            alt: 'Marketing research',
            headline: 'Real reactions — more accurate insights',
            bullets: [
              'Ad testing',
              'Concept and product tests',
              'In-depth interviews',
              'UX/CX research',
              'Customer Journey',
            ],
          },
        ],
      },
      benefits: {
        cards: [
          {
            title: 'Early signal',
            text: 'The ability to act before a problem shows up in the results.',
          },
          {
            title: 'An additional data layer',
            text: 'Not just words and surveys, but the real dynamics of behavior.',
          },
          {
            title: 'Dynamics, not a single assessment',
            text: 'You can track changes over time.',
          },
          {
            title: 'Integration into your processes',
            text: 'RÁZUMA complements existing processes and does not replace specialists’ decisions.',
          },
        ],
      },
      decision: 'RÁZUMA helps make decisions,\nrather than making them instead of the customer.',
      contactsLabel: 'RÁZUMA Contacts',
      security: {
        title: 'Data Security',
        cards: [
          {
            icon: '🔒',
            title: 'Data Encryption',
            text: 'All data is transmitted and stored in encrypted form. Modern encryption protocols compliant with industry standards are used.',
          },
          {
            icon: '🏢',
            title: 'On-Premise Processing',
            text: 'Ability to deploy the platform within the customer’s infrastructure. Video and audio data never leaves your infrastructure.',
          },
          {
            icon: '🛡',
            title: 'Anonymization',
            text: 'RÁZUMA analyzes behavior patterns, not identities. Biometric data is not stored or shared with third parties.',
          },
          {
            icon: '📋',
            title: 'GDPR / 152-FZ Compliance',
            text: 'Data processing complies with Russian Federal Law No. 152-FZ on Personal Data and regulatory recommendations.',
          },
          {
            icon: '✓',
            title: 'Access Control',
            text: 'Flexible role-based access control system. Each user sees only the data permitted by their role.',
          },
          {
            icon: '⏱',
            title: 'Data Retention Policy',
            text: 'Configurable data retention periods. Automatic deletion of recordings after a specified period in accordance with company policy.',
          },
        ],
      },
      cta: {
        demoTitle: 'Try the technology\nin action',
        demoText: 'Upload a sample video or audio and get a sample analysis.',
        demoBtn: 'Try the demo',
        contactTitle: 'Let’s discuss how RÁZUMA\ncan work in your company',
        contactText: 'Tell us about your task — and we will suggest the optimal implementation scenario.',
        contactBtn: 'Discuss a pilot',
      },
    },
    features: {
      title: 'Razuma Features',
      main: 'Key Platform Capabilities',
      cards: [
        'Real-time emotion analysis from photos, video, and audio',
        'A/B testing of creatives for marketing and advertising',
        'Emotional perception assessment for user experience (UX)',
        'Analysis of presentation and public speaking effectiveness',
        'Script optimization to enhance emotional response',
        'API integration with your CRM and business systems',
        'Advanced analytics and personalized expert reports'
      ],
      clients: {
        title: 'Who is Razuma for',
        b2b: 'Large enterprises, agencies, research centers',
        b2c: 'Small and medium businesses, startups, freelancers'
      }
    },
    pricing: {
      title: 'Pricing',
      free: {
        name: 'Free',
        price: 'Free',
        features: [
          'Analysis of 3 photos per month',
          'Up to 30 seconds of video or audio per month',
        ],
      },
      light: {
        name: 'Light',
        price: '9,990 ₽/month',
        features: [
          'Management of up to 10 projects',
          'Unlimited photo analysis',
          'Up to 2 hours of video and audio',
          'Conducting A/B analysis',
          'Full API access',
        ],
      },
      pro: {
        name: 'Pro',
        price: '29,990 ₽/month',
        features: [
          'Unlimited number of projects',
          'Analysis of any number of photos, videos and audio',
          'Conducting A/B analysis',
          'Full API access',
          'Advanced analytics and technical support',
          'Personal expert reports',
        ],
      },
      business: {
        name: 'Business',
        price: 'On request',
        features: [
          'Unlimited number of projects',
          'Analysis of any number of photos, videos and audio',
          'Conducting A/B analysis',
          'Full API access',
          'Advanced analytics and technical support',
          'Personal expert reports',
          'CRM integration',
        ],
      },
      usePlan: 'Use',
      applyPlan: 'Submit application',
    },
    contact: {
      title: 'Contact Information',
      legalInfo: 'Legal Information',
      companyNameLabel: 'Company Name',
      companyName: 'Razuma Technologies LLC',
      legalAddressLabel: 'Legal Address',
      legalAddress: 'Moscow, the territory of the Skolkovo Innovation Center, Bolshoy Boulevard, house 42, building 1',
      inlnLabel: 'Tax ID',
      inln: '9731157733',
      ogrnipLabel: 'State Registration Number',
      ogrnip: '1257700507745',
      contactDetails: 'Contact Details',
      emailLabel: 'Email',
      email: 'info@razuma.tech',
      phoneLabel: 'Phone',
      phone: '+7 (961) 063-67-71',
      workingHoursLabel: 'Working Hours',
      workingHours: 'Mon-Fri: 10:00 - 19:00 (MSK)'
    },
    detector: {
      heroTagline: 'TECHNOLOGY. PEOPLE. SOLUTIONS.',
      heroTitle: 'Try the RÁZUMA demo',
      heroLead: 'Explore the capabilities of our platform and learn how AI helps see more in human emotions, behavior, and reactions.',
      panelInstruction: 'Upload your photo, audio, or video file and choose a processing mode.',
      benefits: {
        fastTitle: 'Fast upload',
        fastText: 'We support the main photo, audio, and video formats.',
        modeTitle: 'Mode selection',
        modeText: 'Use ready-made analysis scenarios for your tasks.',
        resultTitle: 'Analysis result',
        resultText: 'Get detailed analysis and valuable insights.',
      },
      dragFile: 'Drag file here',
      chooseFile: 'Choose file',
      supportedFormats: 'JPG, PNG, MP4, AVI, WEBM, MP3, WAV, AAC, OGG, FLAC (max. 50 MB)',
      consent: 'I consent to the processing of my personal data in accordance with the',
      analyze: 'Analyze',
      processingMode: 'Processing Mode',
      modes: {
        standard: 'Standard Analysis',
        burnout: 'Analysis of a person’s condition',
        externalInfluence: 'External Influence Analysis',
      },
      processing: 'Processing...',
      complete: 'Analysis complete',
      framesProcessed: 'Processed frames: {count}',
      frame: 'Frame',
      frames: 'Frames',
      noImage: 'No image',
      videoAnalysisComplete: 'Video analysis complete',
      selectedFile: 'Selected file',
      imageAnalysis: 'Image Analysis',
      audioAnalysis: 'Audio Analysis',
      audioBurnoutAnalysis: 'Audio Burnout Analysis',
      mainEmotion: 'Main Emotion',
      detectedEmotions: 'Detected Emotions',
      averageEmotions: 'Average Emotions',
      emotionTimeline: 'Emotion Timeline',
      features: {
        title: 'Valence / Arousal',
        valence: 'Valence',
        arousal: 'Arousal',
      },
      duration: 'Duration',
      sampleRate: 'Sample Rate',
      noBurnoutData: 'No burnout analysis data available.',
      analysisResults: 'Analysis Results',
      startingProcessing: 'Starting processing...',
      processingAudio: 'Processing audio...',
      processingVideo: 'Processing video...',
      processingImage: 'Processing image...',
      processingComplete: 'Processing complete!',
      burnoutComplete: 'Burnout analysis complete',
      externalInfluenceComplete: 'External influence analysis complete',
      fileProcessing: 'Processing file...',
      processingFrame: 'Processing frame {current} of {total}',
      processingSegment: 'Processing segment {current} of {total}',
    },
    emotions: {
      anger: 'Anger',
      contempt: 'Contempt',
      disgust: 'Disgust',
      fear: 'Fear',
      neutral: 'Neutral',
      happiness: 'Happiness',
      surprise: 'Surprise',
      sadness: 'Sadness',
      valence: 'Valence',
      arousal: 'Arousal',
    },
    burnout: {
      title: 'Burnout Risk Analysis',
      low: 'Low Risk',
      moderate: 'Moderate Risk',
      high: 'High Risk',
      severe: 'Very High Risk',
      score: 'Risk Score',
      confidence: 'Assessment Confidence',
      topFactor: 'Primary Signal Detected',
      recommendations: 'Manager Actions',
      disclaimer: 'This assessment is based on automated analysis of speech characteristics and their dynamics (when available). It is not a medical diagnosis and should not be used as the sole basis for performance evaluation, disciplinary actions, or other personnel decisions.',
      state: 'Analysis Result',
      componentAnalysis: 'Assessment Components',
      error: 'Analysis Failed',
      basis: 'Basis of Assessment',
      conclusion: 'Condition assessment',
      action: 'Recommendations',
      urgency: 'Urgency and Next Steps',
      factorExplanation: 'Explanation',
      requiresHistory: 'multiple recordings required',
      importantNote: 'Important to Know',

      attentionLevel: {
        title: 'Attention Level',
        mainSignal: 'Primary Signal',
        low: 'Low',
        moderate: 'Moderate',
        high: 'High',
        severe: 'Very High',
        noSignals: 'No pronounced signals detected',
      },
      
      components: {
        exhaustion: 'Emotional Exhaustion',
        prosodicFlattening: 'Prosodic Deviation',
        pauseTempo: 'Pause/Tempo Changes',
        negativeActivation: 'Negative Activation',
        positiveAffectLoss: 'Positive Affect Loss',
      },
      
      states: {
        normal: 'Normal',
        shortStress: 'Short-term Stress',
        sustainedStress: 'Sustained Stress',
        burnoutLike: 'Burnout-like State',
        lowAffect: 'Low Affect (Unspecified)',
        insufficientData: 'Insufficient Data',
      },
      
      factors: {
        'Positive Affect Loss': 'Positive Affect Loss',
        'Negative Activation': 'Negative Activation',
        'Prosodic Flattening': 'Prosodic Flattening',
        'Pause/Tempo Changes': 'Pause/Tempo Changes',
        'Emotional Exhaustion': 'Emotional Exhaustion',
      },
      
      basisText: {
        normal: 'Energy levels, emotional tension, prosodic expressiveness, speech rate, and pause patterns are within the normal range. If previous recordings exist, no negative trend is detected.',
        shortStress: 'Current recording shows isolated changes: increased emotional tension, altered tempo/pauses, or reduced emotional expressiveness. No data yet on whether these changes recur.',
        sustainedStress: 'Changes affect multiple indicators and are observed across several comparable recordings: sustained emotional tension, altered tempo and pauses, reduced positive emotional expressiveness, or signs of decreased energy.',
        burnoutLike: 'Across multiple recordings, a combination of pronounced changes persists: signs of reduced energy, diminished expressiveness, reduced positive emotional tone, tense emotional background, and altered speech rate or pauses.',
        lowAffect: 'Reduced prosodic variety and positive emotional tone detected in speech. Other indicators are insufficient to conclude sustained stress or burnout.',
        insufficientData: 'Recording is too short, contains insufficient speech, background noise, or technical artifacts. Or insufficient previous recordings for dynamic assessment.',
        default: 'Insufficient data for a reliable conclusion.'
      },
      
      conclusionText: {
        normal: 'No significant risk indicators detected. At the time of recording, no pronounced signs of elevated stress or emotional exhaustion were found.',
        shortStress: 'Signs of short-term tension detected. The result may reflect a reaction to an urgent task, difficult conversation, high workload, fatigue, or lack of sleep. It does not indicate burnout.',
        sustainedStress: 'Signs of sustained tension detected. The dynamics may indicate prolonged workload and insufficient recovery. This is not burnout, but indicates an elevated risk of developing it.',
        burnoutLike: 'Signs consistent with professional burnout detected. The result requires attention but is not a diagnosis and does not automatically identify the cause of the condition.',
        lowAffect: 'Reduced emotional expressiveness detected. Causes may include fatigue, mood changes, conversation content, individual speech patterns, or recording conditions. This does not indicate low motivation, indifference, or disloyalty.',
        insufficientData: 'Insufficient data for a reliable conclusion. Analysis result and risk level are undefined.',
        default: 'Insufficient data for a conclusion.'
      },
      
      urgencyText: {
        low: 'Low risk. No significant combination of unfavorable signals detected. No special measures required. Continue routine monitoring.',
        moderate: 'Moderate risk. Isolated changes detected that may be related to increased workload or insufficient recovery. In the coming workdays, have a brief confidential conversation. Clarify workload and agree on 1-2 preventive measures. Reassess in 7-14 days.',
        high: 'High risk. Multiple significant or recurring signals detected requiring management attention. Contact the employee within the next working day. Discuss workload, deadlines, overtime, and necessary support. Monitor dynamics after actions taken.',
        severe: 'Very high risk — requires heightened attention to the employee\'s condition. The combination of signals has reached the upper risk threshold. Contact the employee on the same working day. Clarify well-being and ability to continue current work, review workload. If possible, remove non-urgent tasks and offer corporate support resources.',
        default: 'Risk level is undefined.'
      },
      
      factorExplanations: {
        'positive_affect_loss': 'Reduced positive emotional tone. Speech shows fewer signs of positive emotional engagement. This does not automatically indicate loss of motivation, reduced loyalty, or decreased work quality.',
        'negative_activation': 'Elevated tension level. Speech shows intensified tense or negative emotional tone. The system detects the change but does not determine its cause.',
        'prosodic_flattening': 'Changed prosodic expressiveness. Intonation variety clearly differs from the employee\'s usual pattern — either reduced or increased. This may be related to fatigue, tension, the subject matter, individual speech patterns, or recording conditions.',
        'pause/tempo_changes': 'Changes in speech rate and pauses. Tempo or pause duration differs from the expected pattern. Possible causes include fatigue, high cognitive load, complexity of the subject matter, or technical recording conditions.',
        'emotional_exhaustion': 'Signs of reduced energy. Speech shows a combination of characteristics that may be observed in fatigue and insufficient recovery. This finding should be correlated with workload and dynamics of previous recordings.'
      },
      
      recommendationsList: {
        // Severe risk
        'severe_risk_immediate_action': '⚠️ Very high risk — immediate attention required',
        'contact_employee_same_day': 'Contact the employee on the same working day',
        'check_wellbeing_and_workload': 'Clarify well-being and ability to continue current work',
        'remove_non_urgent_tasks': 'Remove non-urgent tasks if possible',
        'offer_support_resources': 'Offer corporate support resources',
        
        // High risk
        'high_risk_contact_supervisor': 'Contact the employee within the next working day',
        'discuss_workload_and_deadlines': 'Discuss workload, deadlines, overtime, and necessary support',
        'check_dynamics_after_actions': 'Monitor dynamics after actions taken',
        
        // Moderate risk
        'moderate_risk_preventive_measures': 'Moderate risk indicators detected. Preventive measures and monitoring recommended.',
        'discuss_workload_with_supervisor': 'Conduct a confidential discussion about current workload, deadlines, priorities, and overtime.',
        'schedule_regular_breaks': 'Discuss the possibility of regular breaks and recovery time during the workday.',
        'repeat_assessment_7_14_days': 'Reassess in 7-14 days.',
        
        // Low risk / Normal
        'normal_emotional_state_detected': 'No significant signs of increased emotional tension detected.',
        'no_additional_measures': 'No additional measures required.',
        'maintain_balanced_schedule': 'Maintain a balanced work-rest schedule.',
        'regular_check_ups': 'Next assessment recommended according to the established monitoring schedule.',
        
        // Factor-specific recommendations
        'emotional_exhaustion_detected': 'Signs of reduced energy detected. Consider reviewing work and recovery patterns.',
        'voice_monotony_detected': 'Changed speech expressiveness detected relative to the employee\'s usual pattern. This indicator should be evaluated alongside other signals and historical data.',
        'speech_pattern_changes': 'Changes in speech rate or pauses detected. Verify recording context and reassess under comparable conditions.',
        'high_negative_activation': 'Elevated tension level detected. Consider discussing potential sources of stress.',
        'reduced_positive_affect': 'Reduced positive emotional expression detected. This is a non-specific signal and should not be interpreted as loss of motivation or loyalty.',
        
        // Error
        'analysis_failed_retry': '⚠️ Analysis failed. Please try again.',
      },
      
      comments: {
        'need_history_to_distinguish_short_vs_chronic': 'Without a history of multiple recordings, it is not possible to reliably distinguish short-term stress from chronic burnout.',
        'need_dynamics_for_sustained_stress': 'To distinguish short-term stress from sustained risk, dynamics of multiple comparable recordings are needed.',
        'burnout_compatible_not_diagnosis': 'Result is consistent with professional burnout, but is not a diagnosis.',
        'low_affect_nonspecific_signal': 'Reduced emotional expressiveness is a non-specific signal requiring context analysis.',
        'без_истории_нескольких_текущих_записей_нельзя_надежно_различить_short_stress_vs_chronic_burnout': 'To distinguish between short-term stress and sustained risk, multiple comparable recordings are needed. A single recording cannot reliably indicate chronic stress or professional burnout.',
      },
      
      errors: {
        'analysis_failed': 'Analysis failed. Please try again.'
      }
    },
    externalInfluence: {
      title: 'Possible External Influence Signal',
      subtitle: 'Anti-fraud aid from a call recording (pilot)',
      score: 'Signal Intensity Index',
      scoreHint: 'Not a probability of fraud.',
      quality: 'Audio Quality',
      persistentPattern: 'Persistent Pattern',
      contextConfirmed: 'Context Confirmed',
      topFactors: 'Key Signals',
      componentsTitle: 'Assessment Components',
      fragmentTimeline: 'Fragment Scores',
      fragmentLabel: 'Fragment {n}',
      contextApplied: 'Context flags (applied to the analysis)',
      managerAction: 'Manager Action',
      importantNote: 'Important to Know',
      disclaimer:
        'The result is a pilot signal of possible external influence on the employee. It is not proof of fraud, does not establish culpability, and on its own must not block operations or be the sole basis for decisions.',

      states: {
        insufficientData: 'Insufficient Data',
        low: 'No Pronounced Signs Detected',
        elevatedTension: 'Elevated Tension',
        possiblePressure: 'Possible External Pressure',
        probableInfluence: 'Probable External Influence',
        highRisk: 'High External Influence Risk',
      },

      explanationLabel: 'Explanation',

      stateExplanations: {
        low: 'No pronounced changes in emotional state or speech behavior were detected in the voice signal. This does not rule out influence that did not manifest in the voice.',
        elevatedTension:
          'Changes in emotional state and speech behavior were detected. The cause of the changes cannot be determined from the voice signal.',
        possiblePressure:
          'Some changes in emotional state and speech behavior consistent with external pressure were detected. On their own they are not evidence of fraud.',
        probableInfluence:
          'Changes in emotional state and speech behavior are sustained and combine with features typical of external influence. The cause cannot be determined unambiguously from the voice signal.',
        highRisk:
          'A persistent combination of pronounced changes and features typical of external influence was detected. The result is a pilot signal and is not proof of fraud.',
      },

      factors: {
        'NEGATIVE_ACTIVATION_HIGH': 'Elevated emotional tension',
        'PAUSE_TEMPO_DEVIATION': 'Speech tempo / pause deviation',
        'PROSODIC_DEVIATION': 'Prosodic expressiveness deviation',
        'POSITIVE_AFFECT_LOSS_HIGH': 'Reduced positive emotional tone',
        'PERSISTENT_PATTERN': 'Persistent pattern (at least 2 of 3 fragments)',
        'CONTEXT_CONFIRMED': 'Confirmed by context flags',
      },

      actions: {
        'STANDARD_PROCESS': 'Process in standard order',
        'CONTINUE_NO_BLOCK': 'Continue without blocking',
        'ASK_CONTROL_QUESTIONS': 'Ask control questions',
        'ENHANCED_ANTIFRAUD_CHECK': 'Run enhanced anti-fraud check',
        'PRIORITY_ANTIFRAUD_REVIEW': 'Run priority anti-fraud review',
      },

      components: {
        negativeActivation: 'Emotional tension',
        pauseTempoDeviation: 'Speech tempo and pauses',
        prosodicDeviation: 'Prosodic expressiveness',
        positiveAffectLoss: 'Positive emotional tone',
      },

      context: {
        'THIRD_PARTY_INSTRUCTIONS': 'Third-party instructions audible',
        'COACHED_ANSWERS': 'Coached answers',
        'COVER_STORY': 'Cover story',
        'AUDIBLE_THIRD_PARTY_PROMPT': 'Audible prompting by a third party',
        'URGENCY': 'Urgency / time pressure',
        'SECRECY': 'Secrecy demands',
        'SAFE_ACCOUNT': '“Safe account” mention',
        'AUTHORITY_IMPERSONATION': 'Authority impersonation (boss, bank)',
        'PURPOSE_INCONSISTENCY': 'Call purpose inconsistency',
        'UNKNOWN_PAYEE': 'Unknown transfer recipient',
        'EXTERNAL_CALL_IN_PROGRESS': 'External call / call transfer in progress',
      },

      guidance: {
        insufficientData:
          'Insufficient data: the recording contains less than ~30 seconds of meaningful speech, low audio quality, or low assessment confidence. Upload a longer, cleaner call recording.',
        noResult: 'Result unavailable.',
      },

      reasons: {
        lowAudioQuality: 'Reason: audio quality is below the threshold — the recording is too quiet, noisy, or speechless.',
        tooFewFragments: 'Reason: fewer than 3 valid fragments — the recording is too short or too discontinuous.',
        noValidFragments: 'Reason: no fragment could be matched against the baseline profile.',
        lowConfidence: 'Reason: assessment confidence is below the reliability threshold (usually little recognized speech or a weak model signal).',
      },
    },
    footer: {
      copyright: '© 2026 RÁZUMA',
    },
    cookies: {
      text: 'We use cookies to improve website functionality.',
      more: 'Learn more',
      accept: 'Accept',
    },
    modal: {
      title: 'Submit Application',
      name: 'Name*',
      phone: 'Phone*',
      company: 'Company Name',
      submit: 'Submit Application',
      submitting: 'Submitting...',
    },
    errors: {
      fileNotSelected: 'File not selected',
      consentRequired: 'Consent to data processing is required',
      unsupportedFormat: 'Unsupported file format',
      fileTooLarge: 'File too large',
      uploadFailed: 'File upload failed',
      progressCheckFailed: 'Failed to check processing progress',
      processingTimeout: 'Processing took too long',
      processingFailed: 'Processing failed',
      networkError: 'Network error',
    },
  },
};

export const t = (key, lang = 'en', replacements = {}) => {
  const keys = key.split('.');
  let value = translations[lang];

  for (const k of keys) {
    value = value?.[k];
    if (!value) break;
  }

  let text = value || key;

  Object.entries(replacements).forEach(([k, v]) => {
    text = text.replace(`{${k}}`, v);
  });

  return text;
};